import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    {
        name: "Dr. Anita Kurre",
        remarks: "Chairperson"
    },
    {
        name: "Ms. Vimla Sona",
        remarks: "Member"
    },
    {
        name: "Mr. Rajendra Prasad Gendre",
        remarks: "Member"
    },
    {
        name: "Mr. Laxmikant Sinha",
        remarks: "Member"
    },
    {
        name: "Mr. Sanjeev Jangde",
        remarks: "Member"
    }
];

const ScheduledCaste = () => {
    return (
        <>
            <title>SC-ST Committee for Grievances & Support | ISBM University</title>
            <meta
                name="description"
                content="The SC/ST Committee at ISBM University works to ensure fair opportunities, remove discrimination, and support academic & personal growth of SC/ST students."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Scheduled Caste and Scheduled Tribe Committee</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Scheduled Caste and Scheduled Tribe Committee
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Scheduled Caste and Scheduled Tribe Committee</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                ISBM University is committed to upholding the rights and welfare of students
                                belonging to Scheduled Castes (SC) and Scheduled Tribes (ST). To ensure equality
                                and justice, the university has established a dedicated SC/ST Committee.
                                This committee works to address any grievances, safeguard against discrimination,
                                and provide necessary support to help students thrive academically and socially.
                            </p>
                            <p className="text-muted">
                                The committee also ensures compliance with UGC and government regulations,
                                promoting awareness of constitutional rights, educational opportunities, and
                                welfare schemes available to SC/ST students. Regular meetings, sensitization
                                programs, and outreach activities are conducted to foster an inclusive and
                                respectful campus environment where diversity is valued and encouraged.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Scheduled Caste and Scheduled Tribe Committee</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default ScheduledCaste;
